export default __webpack_public_path__ + "e8b49908cecc30a4952fc35b1d6775bc.svg";